import { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import type { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist/types/src/display/api';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

// import { PDFDocument } from 'pdf-lib';

import styles from './PDFViewer.module.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type Props = {
    file: string | Blob;
    onClickCoordinates?: (value: { x: number; y: number; pageNumber: number }) => void;
};

const PDFViewer = ({ file, onClickCoordinates }: Props) => {
    const [renderFile, setRenderFile] = useState<string | Blob | null>(null);
    const [pagesForRender, setPagesForRender] = useState<number[]>([]);
    const [pdfWidth, setPdfWidth] = useState<number>(0);

    const [error, setError] = useState<string | null>(null);

    const ref = useRef<HTMLDivElement | null>(null);
    // const wrapperWidth: number | null = ref.current ? ref.current.offsetWidth : null;
    // const canvasPages = document.getElementsByClassName('react-pdf__Page__canvas');

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        handleResize();
    });

    useEffect(() => {
        setRenderFile(file);
    }, [file]);

    // useEffect(() => {
    //     if (file instanceof Blob) {
    //         getUserClickCoordinates(file);
    //     }
    // }, [file]);

    // useEffect(() => {
    //     console.log(canvasPages.item(0));
    // }, [canvasPages]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    function onDocumentLoadSuccess({ numPages }: PDFDocumentProxy) {
        if (numPages > 0) {
            const renderPages: number[] = [];
            for (let i = 1; i <= numPages; i++) {
                renderPages.push(i);
            }
            setPagesForRender(renderPages);
            setError(null);
        }
    }

    function handleDocumentLoadError(error: Error) {
        setError('Failed to load PDF. You can still download the file.');
    }

    // async function getUserClickCoordinates(pdfFile: Blob) {
    //     console.log('start');
    //     const arrayBuffer = await pdfFile.arrayBuffer();
    //     const pdfDoc = await PDFDocument.load(arrayBuffer);
    //     const pages = pdfDoc.getPages();
    //     if (pages) {
    //         const lastPage = pages[pages.length - 1];
    //         const { width, height } = lastPage.getSize();

    //         const canvasPages = document.getElementsByClassName('react-pdf__Page__canvas');
    //         const canvas = canvasPages.item(pages.length - 1);
    //         // console.log('canvasPages: ', canvasPages);
    //         console.log('canvas: ', canvas);

    //         canvas?.addEventListener('mousedown', (e) => {
    //             // Get the mouse click position relative to the canvas
    //             const rect = canvas.getBoundingClientRect();
    //             const x = (e as MouseEvent).clientX - rect.left;
    //             const y = (e as MouseEvent).clientY - rect.top;
    //             console.log('click');
    //             // Convert the mouse click position to PDF coordinates
    //             const pdfX = (x * width) / canvas.clientWidth;
    //             const pdfY = height - (y * height) / canvas.clientHeight;

    //             // Do something with the PDF coordinates
    //             console.log(`Mouse clicked on last page at (${pdfX}, ${pdfY})`);
    //         });
    //     }
    // }

    function handleResize() {
        if (ref.current) {
            const parentDivWidth = ref.current.offsetWidth;
            setPdfWidth(parentDivWidth);
        }
    }

    function handleClick(
        event: React.MouseEvent<Element, MouseEvent>,
        pageNumber: number,
        page: PDFPageProxy
    ) {
        // Get the canvas element
        // console.log(page);
        event.stopPropagation();
        const canvas = event.target as HTMLCanvasElement;

        // console.log(event);

        // while (canvas?.tagName !== 'CANVAS') {
        //     canvas = canvas?.parentElement as HTMLCanvasElement;
        // }

        if (event.target instanceof HTMLElement && event.target.tagName === 'SPAN') {
            // Stop the event propagation to prevent the canvas element from getting the click event
            event.stopPropagation();
            return;
        }

        // Get the mouse click position relative to the canvas
        const rect = canvas.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        // Get the page size
        const { width, height } = rect;
        // console.log('width: ', width);
        // console.log('height: ', height);
        // console.log('x: ', x);
        // console.log('y: ', y);

        // Convert the mouse click position to PDF coordinates

        if (onClickCoordinates) {
            onClickCoordinates({ x: width / x, y: height / y, pageNumber: pageNumber });
        }
    }

    return (
        <div ref={ref}>
            {error ? (
                <div className={styles.error}>{error}</div>
            ) : (
                pagesForRender &&
                renderFile && (
                    <Document
                        file={renderFile}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={handleDocumentLoadError}
                        options={{
                            standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
                        }}
                    >
                        {pagesForRender.map((pageNum) => (
                            <article key={pageNum} className={styles.page}>
                                {/* <Page pageNumber={page} onLoadSuccess={removeTextLayerOffset} /> */}
                                <Page
                                    key={pageNum}
                                    pageNumber={pageNum}
                                    width={pdfWidth}
                                    onClick={(e, page) => handleClick(e, pageNum, page)}
                                />
                            </article>
                        ))}
                    </Document>
                )
            )}
        </div>
    );
};

export default PDFViewer;
